import  types from './../actions/types';

export const updatePageTitle = (title,bread,buttons) => ({
  type: types.BREADCRUMBS_UPDATE,
  title,
  buttons,
  breadcrumbs:bread
});

